export default {
  rating(state) {
    return state.feedback?.rating?.value
  },
}
